import React, { useEffect } from 'react';
import { routes } from 'routes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isAppInitialized } from 'redux/appInit/selectors';
import { Skeleton, ThemeProvider } from '@mui/material';
import { initializeApp } from 'redux/appInit/actions';
import { selectUiMode } from 'redux/reducers/session';
import { popTheme } from 'popTheme';
import { IntlProvider } from "react-intl";
import useLocalization from "localization/useLocalization";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initializeApp());
  }, [dispatch]);

  const uiMode = useSelector(selectUiMode);
  useEffect(() => {
    setMode(uiMode.toLowerCase());
  }, [uiMode]);

  const [mode, setMode] = React.useState(uiMode.toLowerCase());
  const theme = React.useMemo(() => popTheme({ mode }), [mode]);

  const { locale, copy } = useLocalization()

  return (
    <IntlProvider messages={copy} locale={locale} defaultLocale={locale}>
      <ThemeProvider theme={theme}>
        {useSelector(isAppInitialized) ? (
          <RouterProvider
            router={createBrowserRouter(routes, {
              basename: '/portal',
            })}
          />
        ) : (
          <Skeleton variant="rectangular" animation="wave" width="100vw" height="100vh" />
        )}
      </ThemeProvider>
    </IntlProvider>
  );
}

export default App;
